import { digitsMask } from '@/utils/forms/inputMasks'

import { isMailSourceType } from '../../../lib/stockImportsDefaults'
import { labelWithTooltip } from '../../../RequiredLabel/labelWithTooltip'
import {
  type ConfigFieldContext,
  ConfigTextField,
} from '../../ConfigFields/ConfigFields'
import cn from '../../ConfigModal.module.scss'
import type { ConfigSourceType } from '../../lib/configFormModel'
import { CONFIG_TOOLTIPS } from '../../lib/configModalTexts'

interface ImportProtectionFieldsProps {
  context: ConfigFieldContext
  sourceType: ConfigSourceType
}

function ImportProtectionFields({
  context,
  sourceType,
}: ImportProtectionFieldsProps) {
  return (
    <div className={cn.grid}>
      <ConfigTextField
        context={context}
        name="maxAllowedMissingPercentage"
        title={labelWithTooltip(
          'Макс. % незагруженных',
          CONFIG_TOOLTIPS.maxAllowedMissing
        )}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="missingPercentageSpikeAlert"
        title={labelWithTooltip(
          '% резкого увеличения',
          CONFIG_TOOLTIPS.missingSpike
        )}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="minLoadedPercentOfMedian"
        title={labelWithTooltip(
          'Мин. % распознанных от обычного',
          CONFIG_TOOLTIPS.minLoaded
        )}
        mask={digitsMask}
      />
      <ConfigTextField
        context={context}
        name="maxInvalidQuantityPercentage"
        title={labelWithTooltip(
          'Макс. % строк без количества',
          CONFIG_TOOLTIPS.maxInvalidQuantity
        )}
        mask={digitsMask}
      />
      {isMailSourceType(sourceType) && (
        <ConfigTextField
          context={context}
          name="stalledAlertBusinessDays"
          title={labelWithTooltip(
            'Нет писем, рабочих дней',
            CONFIG_TOOLTIPS.stalledDays
          )}
          mask={digitsMask}
        />
      )}
    </div>
  )
}

export default ImportProtectionFields
